export const getAssignedOptions = () => ([
    { name: l('All'), value: '' },
    { name: l('Assigned'), value: 'true' },
    { name: l('Unassigned'), value: 'false' },
]);
